import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export function AuthCallback() {
  const nav = useNavigate();
  useEffect(() => {
    // supabase-js auto-handles the URL hash via detectSessionInUrl: true.
    // Once a session exists, kick to /.
    supabase.auth.getSession().then(() => nav('/', { replace: true }));
  }, [nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="text-center">
        <div className="mb-6">
          <div className="font-heading text-[22px] font-bold tracking-tight leading-none">
            Holden
            <span className="text-gold font-normal mx-[3px]">|</span>
            GR
          </div>
          <div className="mt-2 text-[10px] font-medium uppercase tracking-[0.18em] text-foreground/55">
            Tool Factory · Admin
          </div>
        </div>
        <div className="inline-flex items-center gap-3 text-[13px] text-foreground/70">
          <span className="inline-block h-3 w-3 rounded-full border-2 border-foreground/20 border-t-gold animate-spin" />
          Signing you in…
        </div>
      </div>
    </div>
  );
}
